import {useCallback} from 'react';

import {ApiDataFieldsTable} from '../../models/api/dataFieldsTableModel';
import {fetchApiAsync} from '../../services/http/http';
import {
  SettingsInvalidateQueriesOptions,
  useSettingsInvalidateQueries,
  useSettingsQuery,
  UseSettingsQueryOptions,
} from '../helpers/useSettingsQuery';

const dataFieldsTableQueryKeyFactory = {
  id: (id: number | undefined | null) => ['data_fields_table', {id}],
};

export function useFetchDataFieldsTable(
  dataTableId: number | undefined | null,
  options?: UseSettingsQueryOptions,
) {
  const {data, ...rest} = useSettingsQuery(
    dataFieldsTableQueryKeyFactory.id(dataTableId),
    async ({company, cancelToken}) => {
      if (!dataTableId) {
        return undefined;
      }
      return fetchApiAsync(ApiDataFieldsTable, `${company.url}/data_fields_table/${dataTableId}`, {
        cancelToken,
      });
    },
    options,
  );

  return {
    dataTable: data,
    ...rest,
  };
}

export function useInvalidateDataFieldsTable() {
  const invalidate = useSettingsInvalidateQueries();

  return useCallback(
    (id: number | undefined | null, options?: SettingsInvalidateQueriesOptions) => {
      if (!id) {
        return;
      }

      invalidate(dataFieldsTableQueryKeyFactory.id(id), options);
    },
    [invalidate],
  );
}
